<template>
  <div class="operational-dashboard-stats">
    <div
      v-for="stat in stats"
      :key="stat.key"
      class="operational-dashboard-stats__card"
    >
      <span class="operational-dashboard-stats__icon">
        <fluent-icon :icon="stat.icon" size="26" />
      </span>
      <div class="operational-dashboard-stats__content">
        <span class="operational-dashboard-stats__value">{{ stat.value }}</span>
        <span class="operational-dashboard-stats__label" :title="stat.label">{{
          stat.label
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatCardsRow',
  props: {
    mineConversations: {
      type: Number,
      default: 0,
    },
    queuedConversations: {
      type: Number,
      default: 0,
    },
    showQueuedConversations: {
      type: Boolean,
      default: true,
    },
    openConversations: {
      type: Number,
      default: 0,
    },
    agentsOnline: {
      type: Number,
      default: 0,
    },
    agentsTotal: {
      type: Number,
      default: 0,
    },
    showAgentsOnline: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    stats() {
      return [
        {
          key: 'mine',
          icon: 'chat',
          value: this.mineConversations,
          label: this.$t('OPERATIONAL_DASHBOARD.STATS.MINE'),
        },
        this.showQueuedConversations && {
          key: 'queued',
          icon: 'queue',
          value: this.queuedConversations,
          label: this.$t('OPERATIONAL_DASHBOARD.STATS.QUEUED'),
        },
        {
          key: 'allOpen',
          icon: 'chat-multiple',
          value: this.openConversations,
          label: this.$t('OPERATIONAL_DASHBOARD.STATS.ALL_OPEN'),
        },
        this.showAgentsOnline && {
          key: 'agentsOnline',
          icon: 'people',
          value: this.$t('OPERATIONAL_DASHBOARD.STATS.AGENTS_ONLINE_VALUE', {
            online: this.agentsOnline,
            total: this.agentsTotal,
          }),
          label: this.$t('OPERATIONAL_DASHBOARD.STATS.AGENTS_ONLINE'),
        },
      ].filter(Boolean);
    },
  },
};
</script>

<style lang="scss" scoped>
.operational-dashboard-stats {
  display: grid;
  gap: var(--space-normal);
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));

  &__card {
    align-items: center;
    background: var(--white);
    border: 1px solid var(--color-border);
    border-radius: var(--border-radius-medium);
    display: flex;
    gap: var(--space-normal);
    min-width: 0;
    padding: var(--space-normal) var(--space-medium);
  }

  &__icon {
    align-items: center;
    background: var(--w-50);
    border-radius: var(--border-radius-medium);
    color: var(--w-500);
    display: flex;
    flex-shrink: 0;
    height: var(--space-larger);
    justify-content: center;
    width: var(--space-larger);
  }

  &__content {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__value {
    color: var(--s-900);
    font-size: var(--font-size-big);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
  }

  &__label {
    color: var(--s-600);
    font-size: var(--font-size-small);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
